import React, { useEffect, useRef, useState } from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${({ theme }) => theme.colors.background};
  width: 100%;
  border-bottom: solid 1px rgb(0, 0, 0, 0.05);
`

const Tab = styled.div<{ isActive: boolean }>`
  display: inline-block;
  padding: 0.5em;
  cursor: pointer;
  margin-inline: 10px;
  color: ${({ theme }) => theme.colors.gray4};

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.colors.gray1};
      font-weight: 500;
    `}
`
const TabsBar = styled.div`
  position: relative;
  display: inline-block;
  margin-bottom: 1px;
`

const Underline = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: black;
  border-radius: 3px 3px 0 0;
`
type Props = {
  active: string
  onChange: (active: string) => void
}

const Tabs: React.FC<Props> = (props) => {
  const { active, onChange, children } = props
  const [sizes, setSizes] = useState({})
  const rootRefElement = useRef<HTMLDivElement>(null)

  const tabRefElements = {}
  let rootBounds

  useEffect(() => {
    const timer = setTimeout(() => recalculateCoordinates(), 100)
    return () => clearTimeout(timer)
  }, [sizes])

  const recalculateCoordinates = () => {
    rootBounds = rootRefElement.current?.getBoundingClientRect()

    const sizes = {}
    Object.keys(tabRefElements).forEach((key) => {
      const tabRef = tabRefElements[key]

      const tabBounds = tabRef?.getBoundingClientRect()

      const leftCoord = tabBounds?.left - rootBounds.left
      const rightCoord = rootBounds.right - tabBounds?.right

      sizes[key] = { leftCoord, rightCoord }
    })

    setSizes(sizes)
  }

  const getUnderlineStyle = () => {
    if (active == null || Object.keys(sizes).length === 0) {
      return { left: '0', right: '100%' }
    }

    const size = sizes[active]

    return {
      left: `${size.leftCoord}px`,
      right: `${size.rightCoord}px`,
      transition: 'left 200ms, right 200ms',
    }
  }

  return (
    <Wrapper>
      <TabsBar className="Tabs" ref={rootRefElement}>
        {React.Children.map(children, (child) => {
          if (!React.isValidElement(child)) return

          return (
            <Tab
              isActive={child.key === active}
              onClick={() => {
                onChange(child.key as string)
              }}
              ref={(el) => (tabRefElements[child.key as string] = el)}
            >
              {child}
            </Tab>
          )
        })}
        <Underline style={getUnderlineStyle()} />
      </TabsBar>
    </Wrapper>
  )
}
export default Tabs
